import * as yup from 'yup'
import { AddressDetails } from '@/common/types'
import { createMobileValidator } from '../../mobile/rules/mobileValidation'
import {
    salutationValidator,
    firstNameValidator,
    middleNameValidator,
    lastNameValidator,
} from '../../name/rules/nameSchema'
import { dateOfBirthValidator } from '@/onboarding/shared/validators/dateOfBirthValidator'

const addressSchema = yup.object({
    addressPrefix: yup.string().optional().nullable(),
    streetNumber: yup.string().required('Please enter street number'),
    streetName: yup.string().required('Please enter street name'),
    streetType: yup.string().optional(),
    city: yup.string().required('Please enter suburb'),
    state: yup.string().required('Please enter state'),
    postCode: yup.string().required('Please enter postal code'),
    country: yup.string().required('Please enter country'),
}) as yup.Schema<AddressDetails>

const optionalAddressSchema = yup.object({
    addressPrefix: yup.string().optional().nullable(),
    streetNumber: yup.string().optional().nullable(),
    streetName: yup.string().optional().nullable(),
    streetType: yup.string().optional().nullable(),
    city: yup.string().optional().nullable(),
    state: yup.string().optional().nullable(),
    postCode: yup.string().optional().nullable(),
    country: yup.string().optional().nullable(),
}) as yup.Schema<AddressDetails>

// Name fields reused from shared validators — see ../../name/rules/nameSchema.ts
export const aboutYouSchema = yup
    .object({
        salutation: salutationValidator,
        firstName: firstNameValidator,
        middleName: middleNameValidator,
        lastName: lastNameValidator,
        dateOfBirth: dateOfBirthValidator,

        residential: addressSchema,
        differentPostalAddress: yup.boolean(),
        postal: yup.mixed<AddressDetails>().when('differentPostalAddress', {
            is: true,
            then: () => addressSchema,
            otherwise: () => optionalAddressSchema,
        }),
        countryCode: yup.string().required('Please select your country code'),
        mobile: createMobileValidator(),
    })
    .required()

export type AboutYouFormValues = yup.InferType<typeof aboutYouSchema>
